import { resolveProfileCountry } from "./businessProfilePayload";

function unwrapBusinessProfile(profile) {
    if (profile == null || typeof profile !== "object") return null;
    return profile.business_details ?? profile.businessDetails ?? profile;
}

function getBusinessName(profile) {
    const data = unwrapBusinessProfile(profile);
    if (!data) return "";
    return String(data.name ?? data.business_name ?? data.businessName ?? "").trim();
}

/**
 * True when there is no usable business profile (missing or no business name).
 */
export function isBusinessProfileEmpty(profile) {
    if (profile == null) return true;
    return !getBusinessName(profile);
}

export function normalizeBusinessProfile(profile) {
    const data = unwrapBusinessProfile(profile);
    if (!data) return null;

    return {
        ...data,
        name: getBusinessName(profile),
        country: resolveProfileCountry(
            data.country ?? data.country_of_origin ?? data.countryOfOrigin
        ),
    };
}
